import { render } from "./TestResultTable.vue?vue&type=template&id=f7044142"
import script from "./TestResultTable.vue?vue&type=script&lang=js"
export * from "./TestResultTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__